import React from 'react';
import { UNIT } from '../../../../settings/settings';
import { isCollegeAnything } from '../../../../utils/transactions-util';
import { coalesce } from '../../../../utils/utils';
import { BaseInputProps } from '../../BaseInput/types';
import { ButtonType } from '../../Button';
import Button from '../../Button/Button';
import './InputButton.scss';

const labelsByUnit = {
  [UNIT.DOLLARS]: '$',
  [UNIT.PERCENT]: '%',
  [UNIT.SHARES]: isCollegeAnything() ? 'Units' : 'Shares',
};

const defaultAllowedUnits = [UNIT.DOLLARS, UNIT.PERCENT, UNIT.SHARES];

export interface InputButtonProps extends BaseInputProps {
  allowedUnits?: UNIT[];
  applyBranding?: boolean;
  onUnitChange;
  selectedInput?: UNIT;
}

const InputButton: React.FC<InputButtonProps> = ({
  allowedUnits = defaultAllowedUnits,
  applyBranding,
  disabled,
  onUnitChange,
  selectedInput = UNIT.DOLLARS,
}) => {
  if (allowedUnits.length < 2) {
    return null;
  }

  return (
    <div className={`input-button ${disabled ? 'input-button-disabled' : ''}`}>
      {allowedUnits.map((unit, index) => (
        <Button
          key={index}
          applyBranding={applyBranding}
          buttonType={ButtonType.PRIMARY}
          className={`btn-trp-primary e2e-input-button-${unit.toLowerCase()} ${
            unit === selectedInput ? 'input-button-selected' : ''
          }`}
          disabled={disabled}
          onClick={() => onUnitChange(unit)}
        >
          {coalesce(labelsByUnit[unit], '?')}
        </Button>
      ))}
    </div>
  );
};

export default InputButton;
